import { route } from '@/ziggy-shim';
import { api } from './LaravelClient';

export default {
  async showMedia(id: Id) {
    return await api(route('api.v1.correspondence.media.show', id), 'get');
  },
};
